<template>
    <div id='usual_active' :class="[theme, padding === 'zero' ? 'no-padding' : '']">
        <div class="content" v-html="content"></div>
        <jgz-loading :loading-show='showLoading'></jgz-loading>
        <div v-show="isiOS" class="ios-warn">{{ $t('invite.not_apple') }}</div>
    </div>
</template>

<script>
//const htmlTxt = "<p>康康这个是什么一个情况咯？</p><p>我也不知道这玩意怎么破咯</p><p>假如发个公告又咋样。</p><p><br></p><p><strong>亲爱的用户：</strong></p><p>为庆祝Binance矿池上线，Binance矿池特推出挖BTC送BNB活动，2020年05月16日上午8:00 至2020年05月29日上午8:00 （香港时间）期间，日均算力≥ 500T 的实名认证用户，均可参与平分1,000 BNB 奖励。</p><p><strong>注意事项 ：</strong></p><ul><li>教程：<a href="https://pool.binancezh.com/en/statistics">如何将BTC算力接入Binance矿池</a>&nbsp;。</li><li>香港时间 2020年05月16日上午8:00 开始记录算力，2020年05月29日上午8:00 结束记录算力，日均算力=单日算力累加/活动天数，登陆账号<a href="https://pool.binancezh.com/cn/statistics">查看每日算力</a>。</li><li>子账号不可作为独立账号参与活动。</li></ul><ul><li>奖励发放：活动结束后5个工作日内，可在用户中心-钱包-分发记录查看。</li><li>活动最终解释权归Binance所有。</li></ul><p><strong>关于Binance矿池：</strong></p><p>依托Binance生态强大的技术与品牌优势，Binance矿池在挖矿的基础上，将矿池平台与交易所平台全面打通，矿工收益可以在币币账户交易、也可以在法币C2C等业务交易，除此之外，Binance矿池也将为矿工提供专属的金融产品服务。更多内容请参考博客：<a href="https://www.binancezh.com/cn/blog/421499824684900541/%E5%B8%81%E5%AE%89%E7%9F%BF%E6%B1%A0%E4%B8%8A%E7%BA%BF%E4%B8%80%E7%AB%99%E5%BC%8F%E5%8A%A0%E5%AF%86%E8%B5%84%E4%BA%A7%E7%BB%BC%E5%90%88%E6%9C%8D%E5%8A%A1%E7%9A%84%E6%8C%96%E7%9F%BF%E5%B9%B3%E5%8F%B0">币安矿池上线：一站式加密资产综合服务的挖矿平台</a>&nbsp;。</p><p><strong>联系我们：</strong></p><p>邮箱：<a href="mailto:poolvip@binance.com">poolvip@binance.com</a></p><p>想要了解更多挖矿以及合作信息，可添加Binance矿池小助手：BinancePool</p><p><strong>相关链接：</strong></p><ul><li><a href="https://binance.zendesk.com/hc/zh-cn/articles/360027287111">如何完成KYC</a>。</li><li><a href="https://binance.zendesk.com/hc/zh-cn/articles/360041370811">BTC挖矿教程</a>。</li><li>进入<a href="https://pool.binancezh.com/cn/home">Binance矿池</a>参与挖矿。</li></ul>"
import JgzLoading from '@/components/JgzLoading.vue'
export default {
    name: 'UsualActive',
    components: {
        JgzLoading,
    },
    data() {
        return {
            isiOS: false,
            activeId: null,
            active: {},
            content: null,
            theme: 'day',
            padding: '',
            showLoading: true,
            language: 'CHINESE',
        }
    },
    mounted() {
        if(this.$i18n.locale === 'zh') {
            this.language = 'CHINESE'
        } else if (this.$i18n.locale === 'zh-h'){
            this.language = 'CHINESETRAD'
        } else {
            this.language = 'ENGLISH'
        }
        
        const u = navigator.userAgent;
        this.isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
        this.theme = this.$route.query.theme
        this.activeId = this.$route.query.activeId;
        document.title = `${this.$t('activity.jgz_activity')}-` + this.$route.query.title;
        // this.activeId = 27
        this.showLoading = true;
        this.getActive()
    },
    watch:{
        $route: {
            handler(newVal) {
                location.reload();
            },
            deep: true
        }
    },
    methods: {
        getActive() {
            // let type = this.newsType;
            this.$MyAxios.getText(`/api/activities/${this.activeId}/content`, {}, 
                response => {
                    this.showLoading = false
                    if(response){
                        let regex = new RegExp('<img', 'g')
                        let result = response.match(regex)
                        let count = !result ? 0 : result.length
                        if(count === 1){
                            this.padding = 'zero'
                        }else{
                            this.padding = ''
                        }
                        this.content = response
                    } else {
                        this.content = `<h1 style="text-align: center;">${this.$t('activity.failed')}</h1>`
                    }
                    
                }, 
                error => {
                    this.showLoading = false
                    console.error(error)
                    this.content = `<h1 style="text-align: center;">${this.$t('activity.failed')}</h1>`
                }
            )
        },
    }
}
</script>

<style lang='less'>
#usual_active {
    min-height: 100vh;
    background: white;
    text-align: left;
    padding: 1.25rem 1.5625rem;
    &.no-padding {
        padding: 0;
    }
    * {
        box-sizing: border-box;
    }
    overflow: hidden;
    position: relative;
    &.night {
        background: #181820;
    }
    h2 {
        font-size: 1.1875rem;
        color: #4B4D59;
        font-weight: bold;
        line-height: 1.5;
    }
    h1 {
        line-height: 1.5;
    }
    &.night h2 {
        color: #E3E3E1;
    }
    &.night span {
        color: #9D9DA6;
    }

    

    font-family: PingFang SC, Lantinghei SC, Helvetica Neue, Helvetica, Arial, Microsoft YaHei, \\\5FAE\8F6F\96C5\9ED1, STHeitiSC-Light, simsun, \\\5B8B\4F53, WenQuanYi Zen Hei, WenQuanYi Micro Hei, sans-serif;

    p {
        font-size: 1rem;
        color: #29293b;
        line-height: 2rem;
        text-align: justify
    }
    &.night p {
        color: #E3E3E1;
        background: #181820;
    }
    a {
        font-size: 1rem;
    }
    strong {
        font-size: 1.2rem;
        margin-top: 1.5rem;
        display: block;
    }

    &.night h1, &.night h2, &.night h3, &.night h4, &.night h5, &.night h6, &.night li{
        color: #E3E3E1;
        background: #181820;
    }
    ul li{
        overflow: hidden;
        display: -ms-flexbox;
        -webkit-line-clamp: 2
    }
    li {
        line-height: 1.8rem;
    }
    ul {
        margin-bottom: 1.5rem;
    }
    .content {
        img {
            max-width: 100%;
        }
    }
    .ios-warn {
        // position: absolute;
        // width: 100vw;
        // bottom: 0px;
        text-align: center;
        color: gray;
    }
}
</style>